import { gantt } from 'dhtmlx-gantt'

/**
 * Handles dynamic date range expansion for Gantt chart during scrolling
 * Automatically extends the visible date range when user scrolls to the edges
 *
 * @param {number} left - Horizontal scroll position
 * @param {number} top - Vertical scroll position (not used in current implementation)
 */
export const handleGanttDynamicScroll = function (left, top) {
  const unit = gantt.getScale().unit;
  const leftPos = gantt.getScrollState().x;
  const left_date = gantt.dateFromPos(leftPos)
  const right_date = gantt.dateFromPos(leftPos + gantt.$task.offsetWidth)

  gantt.config.start_date = gantt.config.start_date || gantt.getState().min_date;
  gantt.config.end_date = gantt.config.end_date || gantt.getState().max_date;

  const max_allowed_date = gantt.date.add(gantt.config.end_date, -2, unit);

  let repaint = false;
  if (!leftPos) {
    gantt.config.start_date = gantt.date.add(gantt.config.start_date, -2, unit);
    repaint = true;
  }
  if (+right_date >= +max_allowed_date) {
    gantt.config.end_date = gantt.date.add(gantt.config.end_date, 2, unit);
    repaint = true;
  }

  if (repaint) {
    setTimeout(function () {
      gantt.render()
      gantt.showDate(left_date)
    }, 20)
  }
}

/**
 * Attaches the dynamic scroll handler to the Gantt chart
 * Call this function after gantt.init() to enable automatic date range expansion
 */
export const attachGanttScrollHandler = function() {
  gantt.attachEvent("onGanttScroll", function (left, top) {
    handleGanttDynamicScroll(left, top);
  });
}